import React from 'react';
import PropTypes from 'prop-types';
import List from '../components/List';
import {
  mapProductData,
  mapServiceData,
} from '../helpers';
import Money from '../../../../common/money';

const HistoryLists = ({ items, shopPayout }) => {
  return (
    <div>
      <div className="layout">
        <div className="layout__item u-1/2">
          <h3 className="u-mb-">Services</h3>
        </div>
        <div className="layout__item u-1/2 u-text-right">
          <h5 className="u-mb-0">Total funds available for payout: <Money cents={shopPayout.transferAmount} /></h5>
          <h5 className="u-mb--">Gift Card Tips Transferred: <Money cents={shopPayout.giftCardTipsAmount} /></h5>
        </div>
      </div>
      <List items={mapServiceData(items, true)} />
      <h3 className="u-mt u-mb-">Products</h3>
      <List items={mapProductData(items, true)} />
    </div>
  );
};

HistoryLists.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  shopPayout: PropTypes.object,
};

HistoryLists.defaultProps = {
  items: [],
  shopPayout: {},
};

export default HistoryLists;
